import { forwardRef } from "react";
import { commas } from "../utilities/Numbers";

import "../css/TextArea.css";

const TextArea = forwardRef(({ children, placeholder, disabled, maxCharacters, setState, ...props }, ref) => {
    return <div className="text-area-wrapper">
        <textarea
            ref={ref}
            className="text-area"
            value={children}

            {...props}

            placeholder={placeholder}
            disabled={disabled}

            onChange={(e) => {
                if (maxCharacters && e.target.value.length > maxCharacters) return;
                setState(e.target.value);
            }}
        />
        
        {maxCharacters && 
            <span 
                className="text-area-max-chars"
                data-max={children && children.length >= maxCharacters}
            >
                {children ? commas(children.length) : "0"}/{commas(maxCharacters)}
            </span>
        }
    </div>
})

export default TextArea;